import React from 'react';
import { BodyText, TextTypes, H3, H1 } from '@citygross/typography';
import { theme } from '@citygross/design-tokens';
var EProductHeader;

(function (EProductHeader) {
  EProductHeader["CARD"] = "card";
  EProductHeader["DETAIL_PAGE"] = "detailPage";
  EProductHeader["LIST_ITEM"] = "listItem";
})(EProductHeader || (EProductHeader = {}));

var ProductHeader = function ProductHeader(_a) {
  var _b, _c, _d, _e, _f, _g;

  var location = _a.location,
      subTitle = _a.subTitle,
      title = _a.title;
  var subTitleUpperCase = subTitle === null || subTitle === void 0 ? void 0 : subTitle.toUpperCase();

  switch (location) {
    case EProductHeader.DETAIL_PAGE:
      return React.createElement("div", null, React.createElement(H1, {
        color: (_b = theme.palette) === null || _b === void 0 ? void 0 : _b.darkest
      }, title), React.createElement(BodyText, {
        color: (_c = theme.palette) === null || _c === void 0 ? void 0 : _c.darkest
      }, subTitleUpperCase));

    case EProductHeader.CARD:
      return React.createElement("div", null, React.createElement(H3, {
        color: (_d = theme.palette) === null || _d === void 0 ? void 0 : _d.darkest
      }, title), React.createElement(BodyText, {
        color: (_e = theme.palette) === null || _e === void 0 ? void 0 : _e.darkest,
        size: TextTypes.TextSize.EXTRASMALL
      }, subTitleUpperCase));

    case EProductHeader.LIST_ITEM:
      return React.createElement("div", null, React.createElement(BodyText, {
        color: (_f = theme.palette) === null || _f === void 0 ? void 0 : _f.darkest,
        fontWeight: "medium",
        size: TextTypes.TextSize.REGULAR
      }, title), React.createElement(BodyText, {
        color: (_g = theme.palette) === null || _g === void 0 ? void 0 : _g.darkest,
        size: TextTypes.TextSize.EXTRASMALL
      }, subTitleUpperCase));

    default:
      return null;
  }
};

export { EProductHeader, ProductHeader };